
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('✅ PWA: Service Worker registered successfully:', registration.scope);

        // Check for updates every 60 seconds
        setInterval(() => {
          registration.update();
        }, 60000);

        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('🔄 PWA: New version available! Refresh to update.');
              // Optionally show a notification to the user
              if (window.confirm('새 버전이 있습니다. 지금 새로고침하시겠습니까?')) {
                window.location.reload();
              }
            }
          });
        });
      })
      .catch((error) => {
        console.error('❌ PWA: Service Worker registration failed:', error);
      });

    // Handle service worker controller change
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('🔄 PWA: Controller changed, reloading page...');
      window.location.reload();
    });
  });
}

// Detect if running as standalone PWA
if (window.matchMedia('(display-mode: standalone)').matches) {
  console.log('📱 PWA: Running as installed app');
  document.documentElement.classList.add('pwa-standalone');
}

// Handle install prompt for PWA
let deferredPrompt;
window.addEventListener('beforeinstallprompt', (e) => {
  console.log('💾 PWA: Install prompt available');
  e.preventDefault();
  deferredPrompt = e;

  // Show custom install button (can be implemented in App.js)
  window.dispatchEvent(new CustomEvent('pwa-install-available', { detail: e }));
});

window.addEventListener('appinstalled', () => {
  console.log('✅ PWA: App installed successfully');
  deferredPrompt = null;
});

// Export install prompt function for use in components
window.showPWAInstallPrompt = async () => {
  if (deferredPrompt) {
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`PWA: User ${outcome === 'accepted' ? 'accepted' : 'dismissed'} the install prompt`);
    deferredPrompt = null;
  }
};
